import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface FollowButtonProps {
  initiallyFollowing?: boolean;
  size?: 'sm' | 'md';
  fullWidth?: boolean;
  variant?: 'solid' | 'outline';
  className?: string;
  onChange?: (isFollowing: boolean) => void;
}
export function FollowButton({
  initiallyFollowing = false,
  size = 'sm',
  fullWidth = false,
  variant = 'solid',
  className = '',
  onChange
}: FollowButtonProps) {
  const [isFollowing, setIsFollowing] = useState(initiallyFollowing);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const next = !isFollowing;
    setIsFollowing(next);
    onChange?.(next);
  };
  const sizeClasses = size === 'sm' ? 'text-xs px-4 py-1.5' : 'text-sm px-5 py-2';
  const stateClasses = isFollowing ? 'bg-surface border border-border text-white hover:bg-surface2' : variant === 'outline' ? 'bg-transparent border border-primary text-primary hover:bg-primary/10' : 'bg-primary text-[#121212] border border-primary hover:bg-primary/90';
  return <motion.button type="button" whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`${fullWidth ? 'w-full' : ''} ${sizeClasses} ${stateClasses} font-bold rounded-full transition-colors inline-flex items-center justify-center gap-1.5 ${className}`} aria-pressed={isFollowing} data-id="element-198">
      {isFollowing && <CheckIcon size={size === 'sm' ? 12 : 14} strokeWidth={3} data-id="element-199" />}
      {isFollowing ? 'Following' : 'Follow'}
    </motion.button>;
}